enum ResearchLink {
  NewPairs = 'New Pairs',
  BigTrades = 'Big Trades',
  WalletOverview = 'Wallet Analyzer',
  Competition = 'Competition',
}

const newPairsLink = {
  name: ResearchLink.NewPairs,
  icon: 'icon-activity',
};

const bigTradesLink = {
  name: ResearchLink.BigTrades,
  icon: 'icon-collections',
};

const walletOverviewLink = {
  name: ResearchLink.WalletOverview,
  icon: 'icon-wallet',
};

const competitionLink = {
  name: ResearchLink.Competition,
  icon: 'icon-competition',
};

export {
  ResearchLink,
  newPairsLink,
  bigTradesLink,
  walletOverviewLink,
  competitionLink,
};
